import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tz/go/egaz/osci/ptl/comn";
import { MASK } from "../../../../lpco/comn/LpcoConstants";

/*
 *  User Management Services
 * !== 사용자 관리 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/acrdt/usr`,
    api: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/ptl/usr/info/usr`,
    nodes: [],
};

export const URLS = {
    osci0103001s: `${BASE.path}/osci0103001s`,
};

export const APIS = {
    // Check Organization User List !==  기관 사용자 목록 조회 ==!
    getOrgUsrList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    // Check Organization User information !==  기관 사용자 정보 조회 ==!
    getOrgUsrInfo: (id: any) => {
        return api.get(`${BASE.api}/${id}`);
    },
    // Create Organization User information !==  기관 사용자 정보 등록 ==!
    createOrgUsrInfo: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },


    // User duplicate check !== 사용자 중복 체크 ==!
    getUsrDuplCheck: (psnTin: any) => {
        return api.get(`${BASE.api}/getUsrDuplCheck`, {
            params: comnUtils.toGetParams({ psnTin: psnTin }),
        });
    },
};

export const SF_ORG_USR_INFO: TFormSchema = {
    id: "form_orgInfo",
    schema: {
        psnTin: {
            type: "text",
            label: "L_TIN",
            required: true,
            letterCase: "upper",
            mask: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
        },
        orgCd: { type: "code", label: "L_ORG_CD", area: "orgCd", popupSize: "md", required: true },
        frgnrYn: {
            type: "radio",
            label: "L_FRGNR_YN",
            options: [
                { label: "Citizen", value: "N" },
                { label: "Foreigner", value: "Y" },
            ],
            defaultValue: "N",
            required: true,
        },

        orgRppnYn: {
            type: "radio",
            label: "L_ORG_RPPN_YN",
            options: [
                { label: "Head of Organization", value: "Y" },
                { label: "General", value: "N" },
            ],
            defaultValue: "N",
            required: true,
        },
        aplcCntyCd: { type: "code", label: "L_APLC_CNTY_CD", area: "cntyCd", popupSize: "md", required: true },
        usrNm: { type: "text", label: "L_USR_NM", required: true },
        usrMoblNo: { type: "text", label: "L_USR_MOBL_NO", required: true },
        usrEmlAddr: {
            type: "text",
            label: "L_USR_EML_ADDR",
            pattern: { value: /[a-z0-9]+@[a-z]+.[a-z]{2,3}/, message: "이메일 형식이 올바르지 않습니다" },
            controlSize: 10,
            required: true,
        },
        rsdtAddr: { type: "text", label: "L_RSDT_ADDR", required: true, controlSize: 10 },
        usrPwd: {
            type: "password",
            label: "L_USR_PWD",
            required: true,
            pattern: {
                value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{10,}$/,
                message: "msg.osc.00225",
            },
        },
        usrPwdCfrm: { type: "password", label: "L_USR_PWD_CFRM", required: true },
        coTin: { type: "text" },
        deptCd: { type: "code", label: "L_ORG_DEPT", area: "orgDeptCd", popupSize: "md" },
        cstmOfceCd: {
            label: "L_CSTM_OFCE_CD",
            type: "code",
            area: "cstmCd",
            popupSize: "md",
            popupParams: {
                // dclrYn: "Y",
            },
        },
    },
};

// Customs Office Code is a mandatory field for ORG(TBS, ZBS, WMA) !== TBS, ZBS, WMA 기관은 세관 사무소 코드 필수 입력 ==!
// export const CSTM_OFCE_CD_RQRD_ARR = new Array("OGAM0001", "OGAM0035", "OGAZ0001");
